import { Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import React from 'react';
import Item from '../../../components/Form/Item';

const Level = () => {
  const formik = useFormikContext();
  return (
    <Item name="Jenis Pelanggaran">
      <Select
        name="level"
        defaultValue={formik.values.level}
        placeholder="Pilih jenis pelanggaran"
        onChange={(value) => {
          formik.setFieldValue("level", value);
        }}
      >
        <Select.Option value={0}>TIDAK ADA SP</Select.Option>
        <Select.Option value={1}>SP 1</Select.Option>
        <Select.Option value={2}>SP 2</Select.Option>
        {/* <Select.Option value={3}>SP 3</Select.Option> */}
      </Select>
      <ErrorMessage component="div" className="gx-text-danger" name="level" />
    </Item>
  );
}

export default Level;